module.exports = __webpack_public_path__ + "7e37682f71f942cb7d8c8e08557e46e4.png";